var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{attrs:{"value":_vm.notifications.show,"multi-line":true},on:{"input":_vm.hideNotification}},[_vm._v("\n  "+_vm._s(_vm.notifications.text)+"\n  "),_c('v-btn',{attrs:{"color":"pink","flat":""},on:{"click":_vm.hideNotification}},[_vm._v("\n    Close\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }